"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = exports.CardDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var router_1 = require("@reach/router");
var status_banner_1 = require("./status-banner");
var badge_1 = require("./badge");
exports.CardDefaultProps = {
  onClick: function () {},
  target: '_blank',
  border: 'none',
  titleMargin: 'normal',
  space: 6,
  hspace: true,
  borderColor: 'line',
  stackedSpace: true
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    display: flex;\n    background-position: top right;\n    position: relative;\n    flex-direction: column;\n    flex-grow: 1;\n    height: 100%;\n  "], ["\n    font-family: ", ";\n    display: flex;\n    background-position: top right;\n    position: relative;\n    flex-direction: column;\n    flex-grow: 1;\n    height: 100%;\n  "])), theme_1.theme.FONT('sans')),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.border === 'full' && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    "], ["\n    "])));
  }),
  desktop: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    button.ellipsis-button {\n      visibility: hidden;\n    }\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "], ["\n    button.ellipsis-button {\n      visibility: hidden;\n    }\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "])))
});
var ContainerLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n    text-decoration: none;\n  "], ["\n    ", "\n    text-decoration: none;\n  "])), ContainerStyles)
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    background-position: top right;\n    text-decoration: none;\n    flex-grow: 1;\n    display: flex;\n    padding-bottom: ", ";\n    flex-direction: column;\n    \n    ", "\n\n    ", "\n\n  "], ["\n    background-position: top right;\n    text-decoration: none;\n    flex-grow: 1;\n    display: flex;\n    padding-bottom: ", ";\n    flex-direction: column;\n    \n    ", "\n\n    ", "\n\n  "])), theme_1.theme.UNIT(4), function (props) {
    return props.space !== 0 && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      padding: 0 2px 2px;\n      margin-top: ", ";\n    "], ["\n      padding: 0 2px 2px;\n      margin-top: ", ";\n    "])), theme_1.theme.UNIT(props.space));
  }, function (props) {
    return !props.hspace && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding-left: 0;\n      padding-right: 0;\n    "], ["\n      padding-left: 0;\n      padding-right: 0;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n\n    ", "\n  "], ["\n    ", "\n\n    ", "\n  "])), function (props) {
    return props.space !== 0 && (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      padding: 0 ", " 2px;\n      margin-top: ", ";\n    "], ["\n      padding: 0 ", " 2px;\n      margin-top: ", ";\n    "])), theme_1.theme.UNIT(props.space), theme_1.theme.UNIT(props.space));
  }, function (props) {
    return !props.hspace && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      padding-left: 0;\n      padding-right: 0;\n    "], ["\n      padding-left: 0;\n      padding-right: 0;\n    "])));
  })
});
var TitleStyles = (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  ", "\n  font-family: ", ";\n  color: ", ";\n  line-height: 1.35em;\n  font-weight: 500;\n  margin-top: 0;\n  margin-bottom: 0.5em;\n  flex-grow: 1;\n\n  ", "\n"], ["\n  ", "\n  font-family: ", ";\n  color: ", ";\n  line-height: 1.35em;\n  font-weight: 500;\n  margin-top: 0;\n  margin-bottom: 0.5em;\n  flex-grow: 1;\n\n  ", "\n"])), theme_1.theme.RESPONSIVE_FONT_SIZE('normal'), theme_1.theme.FONT('serif'), theme_1.theme.COLOR('bold'), function (props) {
  return props.titleMargin === 'none' && (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin-bottom: 0;\n  "], ["\n    margin-bottom: 0;\n  "])));
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    line-height: 1.05em;\n\n    p {\n      line-height: 1.5em;\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    line-height: 1.05em;\n\n    p {\n      line-height: 1.5em;\n    }\n  "])))
});
var FooterStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TitleAndContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    flex-grow: 1;\n  "], ["\n    flex-grow: 1;\n  "])))
});
var StatusBannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 100;\n  "], ["\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 100;\n  "])))
});
var EditControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    display: flex;\n    padding: ", " 0 ", " 0;\n    justify-content: space-between;\n\n    ", "\n  "], ["\n    display: flex;\n    padding: ", " 0 ", " 0;\n    justify-content: space-between;\n\n    ", "\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3.5), function (props) {
    return (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      padding-left: ", ";\n      padding-right: ", ";\n    "], ["\n      padding-left: ", ";\n      padding-right: ", ";\n    "])), props._space == 'none' ? 0 : theme_1.theme.UNIT(props._space), props._space == 'none' ? 0 : theme_1.theme.UNIT(props._space));
  })
});
var BadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TitleAndBadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n\n  "], ["\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ContainerLink: (0, styled_components_1.default)(router_1.Link)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ContainerLinkStyles),
  Title: styled_components_1.default.h1(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  TitleAndBadge: styled_components_1.default.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), TitleAndBadgeStyles),
  TitleAndContent: styled_components_1.default.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), TitleAndContentStyles),
  Anchor: styled_components_1.default.a(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), ContainerLinkStyles),
  Body: styled_components_1.default.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Badge: (0, styled_components_1.default)(badge_1.Badge)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles),
  Content: styled_components_1.default.div(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Footer: styled_components_1.default.div(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles),
  EditControls: styled_components_1.default.div(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), EditControlsStyles),
  StatusBanner: (0, styled_components_1.default)(status_banner_1.StatusBanner)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), StatusBannerStyles)
};
var Card = function (props) {
  var className = props.className,
    image = props.image,
    hoverImage = props.hoverImage,
    children = props.children,
    href = props.href,
    target = props.target,
    title = props.title,
    to = props.to,
    onClick = props.onClick,
    border = props.border,
    borderColor = props.borderColor,
    footer = props.footer,
    space = props.space,
    hspace = props.hspace,
    status = props.status,
    titleMargin = props.titleMargin;
  var inner = React.createElement(React.Fragment, null, status && React.createElement(My.StatusBanner, null, status), image, React.createElement(My.Body, {
    className: "shp--card-body",
    space: space,
    hspace: hspace,
    border: border,
    borderColor: borderColor
  }, React.createElement(My.TitleAndContent, null, React.createElement(My.TitleAndBadge, null, title && React.createElement(My.Title, {
    titleMargin: titleMargin
  }, title)), React.createElement(My.Content, null, children)), footer && React.createElement(My.Footer, null, footer)));
  var isLink = Boolean(href || to && to.match(/^mailto/));
  var linkHref = href || isLink && to;
  return isLink ? React.createElement(My.Anchor, {
    className: className,
    href: linkHref,
    target: target
  }, inner) : to ? React.createElement(My.ContainerLink, {
    to: to,
    border: border,
    className: className
  }, inner) : React.createElement(My.Container, {
    border: border,
    onClick: onClick,
    className: className
  }, inner);
};
exports.Card = Card;
exports.Card.defaultProps = exports.CardDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33;